export default "__VITE_ASSET__b25c3414__"